.root {
  font-size: var(--font-size-body-2);
}
